export class ShareService {
    serverPath: string = 'http://103.122.245.77:3010';
    
}
/*export class ShareService {
    serverPath: string = 'http://pinsouqappservice-env.eba-pakvf9wi.us-east-1.elasticbeanstalk.com';
}*/